import React, { Component } from "react";
import TopBanner from "./components/Banner/TopBanner";
// import MidBanner from "./components/Banner/MidBanner";
import Category from "./components/Category";
import Article from "./components/Article";
import Shim from "../../components/Shim";
import ICP from '../../components/ICP';
import FastSearch from "./components/FastSearch";
class Home extends Component {
  componentDidMount = () => {
    document.title = "浙考之家";
  };
  render() {
    return (
      <div>
        <TopBanner></TopBanner>
        <Category></Category>
        <FastSearch></FastSearch>
        {/* <MidBanner></MidBanner> */}
        <Article></Article>
        <ICP></ICP>
        <Shim></Shim>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/index.js